export default __webpack_public_path__ + "static/media/launchpad-icon-active.abd4271e.svg";